import { PersonMenuItemKey } from './personMenuItemKeys';

export const PERSON_HEADER_STAT_KEYS = {
  BOOKINGS: 'bookings',
  WARRANTS: 'warrants',
  SOPS: 'sops',
  BULLETINS: 'bulletins',
  INCIDENTS: 'incidents',
  ASSOCIATES: 'associates',
  VEHICLES: 'vehicles',
};

export const PERSON_HEADER_STATS = [
  {
    key: PERSON_HEADER_STAT_KEYS.BOOKINGS,
    label: 'Bookings',
    menuKey: PersonMenuItemKey.RELATED_RECORDS,
  },
  {
    key: PERSON_HEADER_STAT_KEYS.WARRANTS,
    label: 'Active Warrants',
    highlight: 'error',
    menuKey: PersonMenuItemKey.RELATED_RECORDS,
  },
  {
    key: PERSON_HEADER_STAT_KEYS.SOPS,
    label: 'SOP',
    menuKey: PersonMenuItemKey.SOPS,
    highlight: 'warning',
  },
  {
    key: PERSON_HEADER_STAT_KEYS.BULLETINS,
    label: 'Active Bulletins',
    menuKey: PersonMenuItemKey.BULLETINS,
    highlight: 'warning',
  },
  {
    key: PERSON_HEADER_STAT_KEYS.INCIDENTS,
    label: 'Incidents',
    menuKey: PersonMenuItemKey.RELATED_RECORDS,
  },
  {
    key: PERSON_HEADER_STAT_KEYS.ASSOCIATES,
    label: 'Associates',
    menuKey: PersonMenuItemKey.ASSOCIATE,
  },
  {
    key: PERSON_HEADER_STAT_KEYS.VEHICLES,
    label: 'Vehicles',
    menuKey: PersonMenuItemKey.VEHICLE_REGISTRATIONS,
  },
];
